import { useMutation } from '@tanstack/react-query';

import * as folderServices from 'services/folder';
import { CustomNotification } from 'common/components';

import { getManageScheduleDownloadKey } from './queries';

export const useUpdateScheduleDownload = (props) => {
  const { folderId } = props;

  const updateScheduleDownload = useMutation({
    mutationKey: ['update-schedule-download-folder'],
    mutationFn: async (params) => {
      try {
        return folderServices.updateFolderScheduleDownload(params);
      } catch (error) {
        console.error('error: ', error);
      }
    },
    meta: {
      invalidates: [getManageScheduleDownloadKey(folderId)],
    },
  });

  return { updateScheduleDownload };
};
